import { render, staticRenderFns } from "./ReleaseNoteAuditLog.vue?vue&type=template&id=0ccb518e"
import script from "./ReleaseNoteAuditLog.vue?vue&type=script&lang=js"
export * from "./ReleaseNoteAuditLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports